// extracted by mini-css-extract-plugin
export var btn = "process-module--btn--fcc0d";
export var col = "process-module--col--bb04b";
export var icon = "process-module--icon--ddf68";
export var item = "process-module--item--6c424";
export var process = "process-module--process--e648d";